<div class="card">
  <div class="header">
    <div>
      <span>Código do serviço </span>
      <span>{{ formatarItemLc116(service?.codigo) || "—" }}</span>
    </div>
  </div>
  <div class="desc" *ngIf="service?.nome || service?.discriminacao">
    {{ service?.nome || service?.discriminacao }}
  </div>
  <div class="body">
    <div class="prop">
      <small>CNAE: </small>
      <span>{{ formatarCnae(service?.cnae) || "—" }}</span>
    </div>
    <div class="prop">
      <small>Cód. tributação: </small>
      <span>{{ service?.codigoTributacao || "—" }}</span>
    </div>
    <div class="prop">
      <small>NBS: </small>
      <span>{{ service?.codigoNbs || "—" }}</span>
    </div>
  </div>
  <div class="footer">
    <app-button
      type="button"
      text="Selecionar"
      (click)="choose.emit()"
    ></app-button>
  </div>
</div>
